<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="加盟账单" />
    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:otherOperations>
        <el-button
          type="primary"
          @click="batchSettlement(bulkData)"
          size="small"
          >批量结算</el-button
        >
      </template>
      <template v-slot:additionalFeatures>
        <div class="procurementDataSummary procurementDataSummary2">
          <ul>
            <li>
              <div>
                <div class="summaryTitle">销售数量</div>
                <div class="today summaryLine">
                  <p>{{ summarizeData.total_num }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">销售金额</div>
                <div class="yesterday summaryLine">
                  <p>¥{{ summarizeData.total_money | money }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">加盟利润</div>
                <div class="summaryLine">
                  <p>¥{{ summarizeData.total_def_money | money }}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div style="height: 20px"></div>
      </template>
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div class="button button_modify" @click="preview(row.row)">
            <i class="iconfont icon-bianji"></i> 明细
          </div>
          <div
            class="button button_modify"
            v-if="row.row.check_status != '已结算'"
            @click="batchSettlement([row.row])"
          >
            <i class="iconfont icon-yulanmoban"></i> 结算
          </div>
        </div>
      </template>
    </basicList>
    <el-dialog
      title="明细"
      :visible.sync="detailsVisible"
      custom-class="addProductPopUpWindow"
      width="80%"
      append-to-body
      @close="closeDetailsVisible"
    >
      <basicList :config="detailData" @search="searchDetailsEvent">
        <template v-slot:form_sn="row">
          <el-link type="primary" @click="purchaseOrder(row.row)">{{
            row.row.form_sn
          }}</el-link>
        </template>
        <template v-slot:operation="row">
          <div style="display: flex; align-items: center">
            <div class="button button_modify" @click="edit(row.row)">
              <i class="iconfont icon-bianji"></i> 编辑
            </div>
          </div>
        </template>
      </basicList>
      <div slot="footer">
        <el-button @click="detailsVisible = false" size="small"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="editVisible"
      custom-class="addProductPopUpWindow"
      width="450px"
      append-to-body
      @close="closeEditVisible"
    >
      <el-form
        :model="editForm"
        size="small"
        label-position="right"
        label-suffix="："
        label-width="120px"
      >
        <el-form-item label="商户">{{ editForm.comp_name }}</el-form-item>
        <el-form-item label="商品名称">{{ editForm.item_name }}</el-form-item>
        <el-form-item label="商品数量">{{ editForm.num }}</el-form-item>
        <el-form-item label="加盟价格">
          <el-input
            v-model="editForm.price_distribution"
            @input="changePrice"
          ></el-input>
        </el-form-item>
        <el-form-item label="加盟利润">{{ editForm.def_money }}</el-form-item>
        <!-- <el-form-item label="加盟利润"
          ><el-input v-model="editForm.def_money"></el-input
        ></el-form-item> -->
      </el-form>
      <div slot="footer">
        <el-button @click="editVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="updateFranchisePrice"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <previewComponents
      @close="closeView"
      :acceptedParameters="previewParams"
      @refresh="refresh"
    ></previewComponents>
  </div>
</template>

<script>
import { getRoles } from "@/utils";
const defaultParameters = {
  page: 1,
  limit: 10,
};
import {
  getList,
  up_check_status,
  getOne,
  upPrice,
} from "@/api/franchiseInvoice";
import { orderSellGetOne } from "@/api/sale";
export default {
  name: "franchiseInvoice",
  components: {
    previewComponents: () => import("@/components/previewComponents"),
  },
  data() {
    return {
      compLevel: 0,
      cur_price: 0,
      firstLevelSearch: [
        {
          label: "加盟商家",
          type: "input",
          key: "comp_name",
        },
        {
          label: "状态",
          type: "select",
          options: [
            {
              label: "未结算",
              value: "未结算",
            },
            {
              label: "已结算",
              value: "已结算",
            },
          ],
          key: "check_status",
        },
        {
          label: "日期",
          type: "daterange",
          key: "create_time",
        },
      ],
      firstLevelColumn: [
        {
          label: "日期",
          prop: "create_time",
          width: 120,
        },
        {
          label: "商户",
          prop: "comp_name",
          width: 200,
        },
        {
          label: "销售数量",
          prop: "num",
          width: 200,
        },
        {
          label: "销售金额",
          prop: "total_money",
          isMoney: true,
          width: 180,
        },
        {
          label: "加盟利润",
          prop: "def_money_all",
          isMoney: true,
          width: 180,
        },
        {
          label: "状态",
          prop: "check_status",
          width: 120,
        },
      ],
      secondarySearch: [
        {
          label: "状态",
          type: "select",
          options: [
            {
              label: "未结算",
              value: "未结算",
            },
            {
              label: "已结算",
              value: "已结算",
            },
          ],
          key: "check_status",
        },
        {
          label: "日期",
          type: "daterange",
          key: "create_time",
        },
      ],
      secondaryList: [
        {
          label: "日期",
          prop: "create_time",
          width: 120,
        },
        {
          label: "销售数量",
          prop: "num",
          width: 200,
        },
        {
          label: "销售金额",
          prop: "total_money",
          isMoney: true,
          width: 180,
        },
        {
          label: "加盟利润",
          prop: "def_money_all",
          isMoney: true,
          width: 180,
        },
        {
          label: "状态",
          prop: "check_status",
          width: 120,
        },
      ],
      // 列表组件参数
      basicListconfig: {
        check: true,
        loading: false,
        operationWidth: 200,
        search: [],
        data: [],
        column: [],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      detailData: {
        loading: false,
        operationWidth: 100,
        search: [],
        data: [],
        column: [],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      detailedList: [
        {
          label: "日期",
          prop: "create_time",
          width: 120,
        },
        {
          label: "商户",
          prop: "comp_name",
          width: 200,
        },
        {
          label: "品名",
          prop: "item_name",
          width: 200,
        },
        {
          label: "采购价",
          prop: "avg_price",
          width: 180,
        },
        {
          label: "加盟价",
          prop: "price_distribution",
          width: 180,
        },
        {
          label: "数量",
          prop: "num",
          width: 120,
        },
        {
          label: "加盟利润",
          prop: "def_money",
          width: 120,
        },
        {
          label: "订单号",
          prop: "form_sn",
          slot: true,
          width: 200,
        },
      ],
      secondaryDetails: [
        {
          label: "日期",
          prop: "create_time",
          width: 120,
        },
        {
          label: "品名",
          prop: "item_name",
          width: 200,
        },
        {
          label: "采购价",
          prop: "avg_price",
          width: 180,
        },
        {
          label: "加盟价",
          prop: "price_distribution",
          width: 180,
        },
        {
          label: "数量",
          prop: "num",
          width: 120,
        },
        {
          label: "加盟利润",
          prop: "def_money",
          width: 120,
        },
        {
          label: "订单号",
          prop: "form_sn",
          slot: true,
          width: 200,
        },
      ],
      summarizeData: {},
      bulkData: [],
      detailsVisible: false,
      editVisible: false,
      editForm: {
        comp_id: "",
        comp_name: "",
        item_name: "",
        num: "",
        price_distribution: "",
        def_money: "",
      },
      previewParams: {
        key: new Date().getTime(),
        visible: false,
        type: "purchaseOrder",
        code: "",
        viewObj: [],
      },
      temporaryRowData: {},
    };
  },
  created() {
    this.compLevel = JSON.parse(getRoles()).comp_level;
    if (JSON.parse(getRoles()).comp_level == 0) {
      this.basicListconfig.search = this.firstLevelSearch;
      this.basicListconfig.column = this.firstLevelColumn;
    } else {
      this.basicListconfig.search = this.secondarySearch;
      this.basicListconfig.column = this.secondaryList;
    }
    this.getlist();
  },
  methods: {
    // 关闭查看
    closeView() {
      this.previewParams.key = new Date().getTime();
      this.previewParams.visible = false;
    },
    refresh() {
      this.preview(this.temporaryRowData);
    },
    purchaseOrder(row) {
      this.temporaryRowData = row;
      this.previewParams.code = row.form_sn;
      if (row.form_sn.includes("XS")) {
        orderSellGetOne({ form_sn: row.form_sn }).then((res) => {
          if (res.code == 1) {
            let payData = res.$pay_list.map((item) => {
              item.pay_price = this.$money(item.pay_price);
              item.all_price = this.$money(item.all_price);
              item.last_price = this.$money(item.last_price);
              return item;
            });
            let item_way = res.item_way.map((item) => {
              if (item.pics) item.pics = item.pics.split(",");
              return item;
            });
            let data = res.$order_list.map((item) => {
              item.name =
                item.item_info.name +
                "(1*" +
                item.item_info.in_package_num +
                ")(" +
                item.item_info.item_number +
                ")";
              item.freeze_num = item.item_info.freeze_num;
              item.price_distribution = this.$money(item.price_distribution);
              item.item_stock_single = item.item_info.item_stock_single;
              item.item_stock_package = item.item_info.item_stock_package;
              item.total_money = this.$money(item.total_money);
              item.algorithm =
                item.price_distribution +
                "*" +
                "(" +
                item.single_num +
                "+" +
                item.package_num +
                "*" +
                item.item_info.in_package_num +
                ")" +
                "=" +
                item.total_money;
              item.total = item.num;
              //   Number(item.single_num) +
              //   Number(item.package_num) * Number(item.item_info.in_package_num);
              return item;
            });
            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "客户",
                    value: res.order_info.customer_name,
                  },
                  {
                    label: "销售门店",
                    value: res.order_info.shop_name,
                  },
                  {
                    label: "业务员",
                    value: res.order_info.customer_user_name,
                  },
                  {
                    label: "制单人",
                    value: res.order_info.user_name,
                  },
                ],
              },
              {
                title: "销售明细",
                type: "array",
                value: data,
                column: [
                  {
                    label: "商品名称",
                    prop: "name",
                    width: 500,
                  },
                  {
                    label: "销售单价",
                    prop: "price_distribution",
                  },

                  {
                    label: "销售总量",
                    prop: "total",
                    align: "center",
                    // children: [
                    //   {
                    //     label: "散",
                    //     prop: "single_num",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "箱",
                    //     prop: "package_num",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "总",
                    //     prop: "total",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    // ],
                  },
                  {
                    label: "小计金额",
                    prop: "total_money",
                    align: "center",
                    // children: [
                    //   {
                    //     label: "金额",
                    //     prop: "total_money",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "算法",
                    //     prop: "algorithm",
                    //     width: 200,
                    //     align: "center",
                    //   },
                    // ],
                  },
                ],
              },
              {
                title: "销售金额",
                type: "object",
                value: [
                  {
                    label: "商品金额",
                    value: this.$money(res.order_info.item_money),
                  },
                  {
                    label: "运费收入",
                    value: this.$money(res.order_info.trans_money),
                  },
                  {
                    label: "订单总金额",
                    value: this.$money(res.order_info.total_money),
                  },
                  {
                    label: "总数量",
                    value: res.order_info.num,
                  },
                  {
                    label: "运费支出",
                    value: this.$money(res.order_info.trans_money_self),
                  },
                  {
                    label: "余额抵扣",
                    value: this.$money(res.order_info.pre_money),
                  },
                  {
                    label: "净毛利",
                    value: this.$money(
                      Number(res.order_info.real_profit_money)
                    ),
                  },
                  {
                    label: "应收总金额",
                    value: this.$money(
                      Number(res.order_info.total_money) -
                        Number(res.order_info.pre_money)
                    ),
                  },
                ],
              },
              {
                title: "收款信息",
                type: "array",
                value: payData,
                column: [
                  {
                    label: "收款账户",
                    prop: "account_name",
                  },
                  {
                    label: "收款",
                    prop: "all_price",
                  },
                  {
                    label: "结款",
                    prop: "pay_price",
                  },
                  {
                    label: "余款",
                    prop: "last_price",
                  },
                  {
                    label: "时间",
                    prop: "create_time",
                  },
                  {
                    label: "类型",
                    prop: "pay_type",
                  },
                  {
                    label: "操作",
                    prop: "operation",
                  },
                ],
              },
              {
                title: "收款信息",
                type: "object",
                value: [
                  {
                    label: "已收金额",
                    value: this.$money(res.order_info.payed_money),
                  },
                  {
                    label: "未收金额",
                    value: this.$money(res.order_info.last_money),
                  },
                ],
              },
              {
                title: "订单备注",
                type: "object",
                value: [
                  {
                    label: "公司名称",
                    value: res.order_info.comp_remark,
                  },
                  {
                    label: "其它备注",
                    value: res.order_info.remark,
                  },
                ],
              },
              {
                title: "溯源信息",
                type: "array",
                value: item_way,
                column: [
                  {
                    label: "ID",
                    prop: "id",
                    width: 80,
                  },
                  {
                    label: "溯源码",
                    prop: "code_value",
                  },
                  // {
                  //   label: "品名",
                  //   prop: "item_name",
                  // },
                  // {
                  //   label: "会员号",
                  //   prop: "customer_id",
                  // },
                  {
                    label: "操作人",
                    prop: "user_name",
                    width: 100,
                  },
                  {
                    label: "溯源照片",
                    prop: "pics",
                    width: 200,
                  },
                  {
                    label: "更新时间",
                    prop: "update_time",
                    width: 100,
                  },
                ],
              },
            ];

            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
            this.previewParams.type = "sale";
          } else {
            this.$message.error("获取详情失败");
          }
        });
      }
    },
    updateFranchisePrice() {
      let data = {
        id: this.editForm.id,
        price_web: this.$multiplication(this.editForm.price_distribution),
        def_money: this.$multiplication(this.editForm.def_money),
      };
      upPrice(data).then((res) => {
        if (res.code == 1) {
          this.$message.success("更新成功！");
          this.editVisible = false;
        } else {
          this.$message.error(res.msg);
        }
      });
      this.getdetails(); // 刷新明细数据
    },

    changePrice(val) {
      this.editForm.def_money = (val - this.cur_price).toFixed(2);
    },
    edit(row) {
      this.editVisible = true;
      this.editForm = JSON.parse(JSON.stringify(row));
      this.cur_price = this.editForm.avg_price;
    },
    closeEditVisible() {
      this.editVisible = false;
    },
    preview(row) {
      this.detailsVisible = true;
      if (JSON.parse(getRoles()).comp_level == 0) {
        this.detailData.operation = true;
        this.detailData.search = this.firstLevelSearch;
        this.detailData.column = this.detailedList;
      } else {
        this.detailData.operation = false;
        this.detailData.search = this.secondarySearch;
        this.detailData.column = this.secondaryDetails;
      }
      this.detailData.searchParameters.comp_id = row.comp_id;
      this.detailData.searchParameters.begin_at = row.create_time;
      this.detailData.searchParameters.end_at = row.create_time;
      this.detailData.search.map((item) => {
        if (item.key == "create_time") {
          item.value = [row.create_time, row.create_time];
        }
        return item;
      });
      this.getdetails();
    },
    getdetails() {
      getOne(this.detailData.searchParameters).then((res) => {
        if (res.code == 1) {
          this.detailData.data = res.data.map((item) => {
            item.avg_price = this.$money(item.avg_price);
            item.price_distribution = this.$money(item.price_distribution);
            item.def_money = this.$money(item.def_money);
            return item;
          });
          this.detailData.total = res.count;
        }
      });
    },
    closeDetailsVisible() {
      this.detailsVisible = false;
    },
    batchSettlement(bulkData) {
      if (bulkData.length == 0) {
        this.$message.error("请先选择要结算的数据！");
        return;
      }
      this.$confirm("将对本条数据执行结算操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          let ids = bulkData.map((item) => {
            return item.comp_id + "#" + item.create_time;
          });
          let data = {
            comp_id: ids.join(","),
            check_status: 1,
          };
          up_check_status(data).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.getlist();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch((rej) => {
          // console.log('用户取消了操作');
        });
    },
    handleSelectionChange(val) {
      this.bulkData = val;
    },
    searchDetailsEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.detailData.searchParameters.page = page;
        if (pageSize) this.detailData.searchParameters.limit = pageSize;
        this.getdetails();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.detailData.searchParameters.begin_at;
              delete this.detailData.searchParameters.end_at;
            } else {
              this.detailData.searchParameters.begin_at = data[key][0];
              this.detailData.searchParameters.end_at = data[key][1];
            }
          }
          this.detailData.searchParameters[key] = data[key];
        }
        this.detailData.search.map((item) => {
          if (item.key == "create_time") {
            item.value = [
              this.detailData.searchParameters.begin_at,
              this.detailData.searchParameters.end_at,
            ];
          }
          return item;
        });
        this.detailData.searchParameters.page = 1;
        this.getdetails();
      }
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.searchParameters.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.basicListconfig.searchParameters.begin_at;
              delete this.basicListconfig.searchParameters.end_at;
            } else {
              this.basicListconfig.searchParameters.begin_at = data[key][0];
              this.basicListconfig.searchParameters.end_at = data[key][1];
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }

        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.searchParameters.comp_id = JSON.parse(
        getRoles()
      ).comp_id;
      this.basicListconfig.loading = true;
      getList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.summarizeData = {
            total_money: res.total_money,
            total_num: res.total_num,
            total_def_money: res.total_def_money,
          };
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/franchiseInvoice/index.vue